export const getLocalStorageByKey = key => {
  let data;
  try {
    data = JSON.parse(localStorage.getItem(key));
  } catch (e) {
    /* eslint-disable no-console */
    console.error(e);
    data = null;
    /* eslint-enable no-console */
  }

  return data;
};

export const changeLocalStorageKey = (oldKey, newKey) => {
  if (localStorage) {
    try {
      const data = localStorage.getItem(oldKey);
      if (data) {
        localStorage.setItem(newKey, data);
        localStorage.removeItem(oldKey);
      }
    } catch (e) {
      localStorage.removeItem(oldKey);
    }
  }
};
